import { pm } from '@renderer/modules/api/pm';
import type { ApiResponse, Position } from '@renderer/modules/types';

export async function getPositions(filters?: { asset_ids?: string[] }): Promise<ApiResponse<Position[]>> {
  return pm.getPositions(filters);
}


